
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commercial-host",
      function () {
        return require("private-next-pages/commercial-host/index.js");
      }
    ]);
  